export default __webpack_public_path__ + "static/media/Somesekha@2x.264ad001.png";